module.exports = __webpack_public_path__ + "static/media/296145.0b0b65e8.jpg";